<template>
    <MainContentSearchable title="Listado de usuarios" id="usuarios" v-model="filters" :meta="loading ? {} : usuarios?.meta" @updated="debouncedGetUsuarios">
        <template v-slot:header>
            <b-card-title class="pt-2">Listado de usuarios</b-card-title>
            <div class="d-flex flex-wrap justify-content-end flex-md-row flex-column">
                <Button class="ml-auto mb-3 mr-md-2" @click="showModal('borrar-listado-' + comunicado_id)" v-if="usuarios?.data?.length > 0" variant="danger">Borrar Usuarios</Button>
                <Button class="ml-auto mb-3 mr-md-2" @click="showModal('cargar-usuarios')">Cargar usuarios</Button>
            </div>
            <CargarUsuarios :key="reloadComponent" :comunicado_id="comunicado_id" @close="closeModal" />
            <BorrarModalComponent
                :name="'borrar-listado-' + comunicado_id"
                :title="'Borrar usuarios del comunicado ' + comunicado_id"
                confirmButton="¿Está segur@ de borrar todos los usuarios cargados de este comunicado?"
                @close="closeModal('borrar-listado-' + comunicado_id, false)"
                @confirm="borrarListadoUsuarios"
            />
        </template>
        <template v-slot:content>
            <div>
                <h6 class="text-info">
                    <b-icon icon="people-fill" class="mr-1" />
                    Total de comunicados enviados: 
                    <b-badge variant="primary" class="ml-2 px-3 py-1">{{ totalUsuarios }}</b-badge>
                </h6>
                <hr/>
            </div>
            <div :class="['table', { 'expanded': usuarios.data?.length <= 3 }]">
                <b-table hover :items="usuarios?.data" :busy="loading" :fields="fields">
                    <template #cell(enviado)="data">
                        <CheckOrCross :condition="data.value"/>
                    </template>
                    <template #cell(leido)="data">
                        <CheckOrCross :condition="data.value"/>
                    </template>
                    <template #cell(opciones)="{ item }">
                        <OpcionesDropdownTableComponent 
                            v-bind:options="[
                                { type: 'action', action: () => showModal('borrar-' + item.id), label: 'Borrar' }
                            ]"
                        />
                        <BorrarModalComponent
                            :name="'borrar-' + item.id"
                            :title="'Borrar usuario ' + item.name"
                            confirmButton="¿Está segur@ de borrar este usuario?"
                            @close="closeModal('borrar-' + item.id, false)"
                            @confirm="borrarUsuario(item.id)"
                        />
                    </template>
                </b-table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable.vue';
    import CargarUsuarios from '@/components/backend/comunicados/CargarUsuarios';
    import CheckOrCross from "@/components/backend/components/CheckOrCross";
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        data() {
            return {
                usuarios: { meta: { current_page: 1 } },
                totalUsuarios: 0,
                loading: false,
                reloadComponent: 1,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: 'name', label: 'Nombre'},
                    { key: 'email', label: 'Email', class: 'text-center' },
                    { key: 'telefono', label: 'Teléfono', class: 'text-center' },
                    { key: 'enviado', label: 'Enviado', class: 'text-center' },
                    { key: 'leido', label: 'Leído', class: 'text-center' },
                    { key: 'opciones', label: 'Opciones' }
                ]
            }
        },
        methods: {
            getUsuarios() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    comunicado_id: this.comunicado_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.users'), params).then(res => {
                    this.usuarios = res.data;
                    this.totalUsuarios = res.data.meta.total;
                }).finally(() => this.loading = false);
            },
            borrarListadoUsuarios() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    comunicado_id: this.comunicado_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.users.borrarListado'), params)
                    .then(res => {
                        this.$toast.success(res.data?.message);
                        this.closeModal('borrar-listado-' + this.comunicado_id, true)
                        this.getUsuarios();
                    })
                    .catch(err => {
                        const message = err?.response?.data?.message || 'Ocurrió un error al borrar los usuarios.';
                        this.$toast.error(message);
                    })
                    .finally(() => this.loading = false);
            },
            borrarUsuario(usuario_id) {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    comunicado_id: this.comunicado_id,
                    comunicado_user_id: usuario_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.users.borrar'), params).then(res => {
                    this.$toast.success(res.data?.message);
                    this.closeModal('borrar-' + usuario_id, true)
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, recargar) {
                this.$modal.hide(modal);
                this.reloadComponent++;

                if (recargar) {
                    this.getUsuarios();
                }
            }
        },
        computed: {
            comunicado_id() {
                return parseInt(this.$route.params.comunicado_id);
            }
        },
        created() {
            this.getUsuarios();
            this.debouncedGetUsuarios = _.debounce(this.getUsuarios, 500);
        },
        components: {
            MainContentSearchable, CargarUsuarios, CheckOrCross, OpcionesDropdownTableComponent, BorrarModalComponent
        }
    }
</script>

<style scoped>
.table {
    overflow: auto;
}
.table.expanded {
    padding-bottom: 150px !important;
}
</style>